import {btn, comp, fieldset, form, Notifier, tbar, TextField, textfield, Window} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";
import {CurrentUser} from "./services/CurrentUser.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwErrorParser} from "./util/IfwErrorParser.js";

export class ForcePasswordChangeDialog extends Window {
	private passwordFld: TextField;
	private passwordConfirmFld: TextField;
	private currentPassword: string;

	constructor(config: { password: any; }) {
		super();
		this.title = t("Reset password");
		this.modal = true;
		this.width = 600;
		this.maximizable = false;
		this.draggable = false;
		this.resizable = false;
		this.closable = false;

		this.currentPassword = config.password;

		const p = comp({
			tagName: "p",
			html: t("Please enter a new password for better security.")
		});
		this.items.add(p);
		const f = form({
				flex: 1,
				cls: "vbox",
				handler: (form) => {
					const cu = CurrentUser.get(), values = form.value;
					if(cu.forcePasswordChange){
						const url = ServerApi.url("auth/users/"+cu.id+"/change-password",{});

						ServerApi.call(url,{password: values.password, currentPassword: this.currentPassword}, "PUT").then((response) => {
							if(response.success) {
								Notifier.success(t("Your password has been changed"), 3000);
								setTimeout(() => this.close(), 3000);
								return;
							}
							if (response.data && response.data.validationErrors) {
								IfwInvalidator.setInvalidPasswordMessage(this.passwordFld, response.data.validationErrors.password);
							} else {
								Notifier.error(t("Unknown error"), 3000);
								setTimeout(() => this.close(), 3000);
								return
							}
						}).catch((reason) => {
							const o = IfwErrorParser.parseAndReturn(reason);
							if (!o) {
								return;
							}
							IfwInvalidator.setInvalidPasswordMessage(this.passwordFld, o["password"]);
							this.passwordFld.focus();
							this.unmask();
						});
					}
				}
			},
			fieldset({flex: 1},
				this.passwordFld = textfield({
					label: t("Password"),
					name: "password",
					id: "password",
					type: "password",
					required: true,
					icon: "lock",
					autocomplete: "off",
					listeners: {
						change: (_fld: TextField, newValue, _oldValue) => {
							const dupe = this.passwordConfirmFld.value;
							if (dupe && dupe !== newValue) {
								this.passwordConfirmFld.setInvalid(t("The passwords don't match"));
							}
						},
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}
				}),

				this.passwordConfirmFld = textfield({
					label: t("Confirm password"),
					name: "passwordConfirm",
					id: "passwordConfirm",
					type: "password",
					required: true,
					icon: "lock",
					autocomplete: "off",
					listeners: {
						change: (fld: TextField, newValue, _oldValue) => {
							const dupe = this.passwordFld.value;
							if (dupe && dupe !== newValue) {
								fld.setInvalid(t("The passwords don't match"))
							}
						},
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}
				})
			),
			tbar({cls: "ifw-bbar"}, "->",
				btn({html: t("Change"), type: "submit"})
			)
		);
		this.items.add(f,);
	}
}